import React from "react";
import { isTablet } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import { MarketLogo, textLogo } from "src/assets/images/logo";
import { PATH_URL } from "src/interfaces";

interface PropsType {
  styles?: React.CSSProperties;
  isLink?: boolean;
}

const NafutelMarketLogo = ({ styles, isLink }: PropsType) => {
  const navigate = useNavigate();
  const onClick = () => {
    if (isLink) {
      navigate(PATH_URL.RESALE_HOME);
    }
  };

  return (
    <div
      onClick={onClick}
      className="d-flex align-items-center"
      style={{ ...styles, cursor: isLink ? "pointer" : "auto" }}
    >
      <MarketLogo
        width={isTablet ? 28 : undefined}
        height={isTablet ? 28 : undefined}
      />
      <div
        style={{
          marginTop: isTablet ? 7 : "20px",
          marginLeft: "10px",
        }}
      >
        <img
          src={textLogo}
          alt=""
          width={isTablet ? 67 : undefined}
          height={isTablet ? 16 : undefined}
        />
        <p
          style={{
            position: "relative",
            top: isTablet ? 0 : "-3px",
            fontSize: isTablet ? 10 : "17px",
            color: "#ffffff",
            marginLeft: "15px",
            marginBottom: isTablet ? 10 : undefined,
          }}
        >
          Market
        </p>
      </div>
    </div>
  );
};

export { NafutelMarketLogo };
